export default __webpack_public_path__ + "static/og-zappi-60503ce4835015d50cc39720edb605bc.jpg";